define('commentsTags',[
  'module',
  'underscore'
], function (
  module,
  _
) {
  'use strict';

  module.exports = {
    get: function (showAll) {
      var tags = [];
      
      if(showAll) {
        tags.push({
          id: '',
          selected: false,
          visible: true,
          name: _.i18n('common.all'),
          contextMenu: false
        });
      }

      tags = tags.concat([  
        {
          id: 'commercial',
          selected: false,
          visible: true,
          name: _.i18n('common.commercial'),
          contextMenu: true
        }, {
          id: 'vip',
          selected: false,
          visible: true,
          name: _.i18n('common.vip'),
          contextMenu: true
        }, {
          id: 'support',
          selected: false,
          visible: true,
          name: _.i18n('common.support'),
          contextMenu: true
        }, {
          id: 'tracking',
          selected: false,
          visible: true,
          name: _.i18n('common.tracking'),
          contextMenu: true
        }, {
          id: 'sav',
          selected: false,
          visible: true,
          name: _.i18n('common.sav'),
          contextMenu: true
        }, {
          id: 'account',
          selected: false,
          visible: true,
          name: 'Account',
          contextMenu: true
        }, {
          id: 'archived',
          selected: false,
          visible: true,
          name: _.i18n('common.archived'),
          contextMenu: true
        }, {
          id: 'order',
          selected: false,
          visible: true,
          name: _.i18n('common.order'),
          contextMenu: true
        }, {
          id: 'addcost',
          selected: false,
          visible: true,
          name: _.i18n('price.addCost'),
          contextMenu: false
        }
      ]);    

      return tags;
    }
  };
});

